import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllConsultList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Counseling/CounselingList");
  }

  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}


class CounselingGroupCounselList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Counseling/CounselingGroupCounselList");
  }

  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}



class ListCounselingPackageForAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Counseling/ListCounselingPackageForAdmin");
  }

  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateCounselingPackage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Counseling/CreateCounselingPackage");
  }

  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateCounselingPackage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Counseling/UpdateCounselingPackage");
  }

  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CounselingPackageReport extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Counseling/CounselingPackageReport");
  }

  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CounselingGroupCounselList,
  GetAllConsultList,
  ListCounselingPackageForAdmin,
  CreateCounselingPackage,
  UpdateCounselingPackage,
  CounselingPackageReport
};
